module.exports = __webpack_public_path__ + "static/media/19ESCAP19.f9bbd26b.jpg";